import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ShieldCheckIcon, StarIcon, RepeatIcon, ActivityIcon } from 'lucide-react';
export function AboutMission() {
  const principles = [{
    name: 'Safety',
    icon: ShieldCheckIcon
  }, {
    name: 'Quality',
    icon: StarIcon
  }, {
    name: 'Consistency',
    icon: RepeatIcon
  }, {
    name: 'Efficacy',
    icon: ActivityIcon
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-98">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-99">
        <AnimateOnScroll className="text-center" data-id="element-100">
          <p className="text-black text-base lg:text-lg leading-[1.8] font-body mb-12" data-id="element-101">
            Be CLINICAL is an evidence based medical and aesthetic clinic
            serving the San Francisco Bay Area. Specializing in preventative
            aging and aesthetic enhancements—we offer both medical and aesthetic
            treatments for full, comprehensive care. Our physician owned and
            operated San Ramon clinic is under the leadership of Fiona Frie MD.
            Founded in 2017, Be CLINICAL was built upon the core principles of{' '}
            <strong className="text-[#FF1493] font-semibold" data-id="element-102">
              safety, quality, consistency, and efficacy
            </strong>
            . Our mission is to take a clinical and comprehensive approach to
            medical and aesthetic medicine—ensuring our patients look and feel
            great at any age!
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12" data-id="element-103">
            {principles.map((principle, index) => <div key={index} className="flex flex-col items-center gap-3" data-id="element-104">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm" data-id="element-105">
                  <principle.icon className="text-[#FF1493]" size={24} strokeWidth={1.5} data-id="element-106" />
                </div>
                <span className="text-black font-heading uppercase tracking-widest text-sm font-medium" data-id="element-107">
                  {principle.name}
                </span>
              </div>)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}